import type { FaireProductEntity } from "../../entity_types/product";

export const p_hb6aqvbd64: FaireProductEntity = {
  token: "p_hb6aqvbd64",
  type: "product",
  name: "Shampoo Backwash Station for Salons with ABS Shampoo Bowl",
  brandToken: "b_jquqgry9jx",
  brandName: "39F Inc.",
  imageUrl:
    "https://cdn.faire.com/fastly/52d5901a2e137e8f94c32782f55d812876f4a04ec1a3fc65659cd4c5c1ae33a1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8ee0d46f9b20dc247c0499911106a226fa64810b1c893fe4b1289beba5697403.jpeg",
    "https://cdn.faire.com/fastly/4b5ae4a0ad608301898f0f6ddd695451e7560129e20c75a564db1f718b6940a5.jpeg",
    "https://cdn.faire.com/fastly/44213ec7f4aa21db50525716e9fa9c2913550b0853c82ea5b8378a280ac7bca6.jpeg",
    "https://cdn.faire.com/fastly/8af17aa431b836c1aae209ccffe11349fb181b444f26111a65be07429212c5f9.jpeg",
    "https://cdn.faire.com/fastly/5f5db001aa50c6e29a02c2371bb2c6b61885a07c57dc23daf8a0f99316846d38.jpeg",
    "https://cdn.faire.com/fastly/2fef5019786bdcc1422466aebb69fff9115062f7d79622acff32f691571b47fb.jpeg",
    "https://cdn.faire.com/fastly/de3ae490cd4fb5c865544cd24f1117eacb1ba8d1280724178ea8d16f3d5e0944.jpeg",
  ],
  priceDollars: 272.27,
  description:
    "Upgrade your salon setup with this multifunctional Shampoo Backwash Station. Designed for professional use, it features a high-quality ABS shampoo bowl, smooth waterproof MDF surface, and ample storage with three-tier shelving and a concealed cabinet. Whether in a spa, beauty studio, or barbershop, this unit offers an organized and stylish solution. Its classic modern design saves space while remaining portable and easy to clean, making it a practical addition to any salon.\n\nKey Features:\n\nMulti-Functional Design: Includes shampoo bowl and station to match various shampoo or barber chairs.\n\nSmart Storage Layout: Features a wide tabletop and three open shelves of varying heights for efficient item placement.\n\nConcealed Plumbing: Cabinet doors hide plumbing for a clean and professional look.\n\nDurable Materials: ABS bowl, stainless steel drain, UPC-certified nozzle, waterproof MDF construction.\n\nEasy Assembly & Cleaning: Two-package delivery with detailed instructions.",
  tags: [],
  msrpDollars: 435.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:55.154Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
